import "./Answer.module.css";
import { RelatedCaseletProps } from "../chat/RenderFollowupCaselet";

type HtmlParsedAnswer = {
  answerHtml: string ;
  // citations: string[];
  followupQuestions: string[];
  relatedCaselets: RelatedCaseletProps[];
};



export function parseAnswerToHtml(
  answer: string,
  followupQuestions: string[],
  relatedCaselets: RelatedCaseletProps[],
  // onCitationClicked: (citationFilePath: string) => void,
  // citationWithLink?: any
): HtmlParsedAnswer {
  // const citations: string[] = [];
  // function isCitationPresent(citationToCheck: string): boolean {
  //   const caseSensitiveMatch = citationWithLink.find(
  //     (item: any) =>
  //       item.citation.split("/").pop().trim() === citationToCheck.trim()
  //   );
  //   return caseSensitiveMatch !== undefined;
  // }
  // // const [citationsState, setCitationsState] = useState<string[]>()
  let parsedAnswer = answer.trim();
  // // Convert citationWithLink to a Map for easy lookup
  // const citationMap = new Map<string, string>();
  // if (citationWithLink) {
  //   citationWithLink.forEach((item: { citation: string; link: string }) => {
  //     citationMap.set(item.citation.split("/").pop() || "", item.link);
  //   });
  // }
  // const citationMapTitleWithPart = new Map<string, string>();
  // if (citationWithLink) {
  //   citationWithLink.forEach((item: { citation: string; title: string }) => {
  //     citationMapTitleWithPart.set(
  //       item.citation.split("/").pop() || "",
  //       item.title
  //     );
  //   });
  // }
  //console.log("parsedAnswer: ", parsedAnswer);
  let formattedText: string = parsedAnswer
    .split("\n")
    .map((line: any) => line + "\n")
    .join("");
  // console.log("formattedText: ", formattedText);
  let lastIndex = formattedText.length;
  for (let i = formattedText.length - 1; i >= 0; i--) {
    if (formattedText[i] === "]") {
      break;
    } else if (formattedText[i] === "[") {
      lastIndex = i;
      break;
    }
  }

  const truncatedAnswer = formattedText.substring(0, lastIndex);
  formattedText = truncatedAnswer;
  const paragraphs = formattedText.split(/\n/g);
  const fragments: string[] = paragraphs.map((paragraph) => {
    const parts = paragraph.split(/\[([^\]]+)\]/g);
    // let citationIndex: number;
    const paragraphFragments = parts.map((part, partIndex) => {
      if (partIndex % 2 === 0) {
        if (part.trim() === "") {
          return;
        }
        return part;
      } 
    });
    return paragraphFragments.join("");
  });

  return {
    answerHtml: fragments.join("\n"),
    followupQuestions,
    relatedCaselets,
  };
}
